import {
  MaterializedProcessDocument,
  MaterializedProcessQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { MaterializedProcess } from 'modules/processes/domain'

export const useMaterializedProcess = (variables: MaterializedProcessQueryVariables) => {
  const { data, loading } = useQuery(MaterializedProcessDocument, {
    skip: !variables.id,
    variables,
  })

  const materializedProcess = data?.processes.materializedProcessesConnection?.nodes[0]

  const materializedProcessTransformed = materializedProcess
    ? {
        ...materializedProcess,
        materializedSteps: materializedProcess.materializedSteps.map((step) => ({
          ...step,
          materializedItems: step.materializedItems.map((materializedItem) => ({
            ...materializedItem,
            assigeeIds: materializedItem.materializedAssignees.map((assignee) => assignee.accessId),
            status: materializedItem?.materializedAction?.status || materializedItem.status,
            reason: materializedItem?.materializedAction?.reason,
            item: {
              ...materializedItem.item,
              configurationId: materializedItem?.item?.taskConfiguration?.id,
              title:
                materializedItem.item?.action?.actionConfiguration?.title ||
                materializedItem.item?.taskConfiguration?.title,
              mandatory: materializedItem.item?.taskConfiguration?.mandatory,
              instruction: materializedItem.item?.taskConfiguration?.instruction,
              assigneeIds: materializedItem.item?.itemAssignee?.assigneeIds,
            },
          })),
        })),
        process: {
          ...materializedProcess.process,
          steps: materializedProcess.process.steps.map((step) => ({
            ...step,
            items: step.items.map((item) => ({
              ...item,
              instruction: item?.taskConfiguration?.instruction,
              mandatory: item?.taskConfiguration?.mandatory,
              offsetAmount: item?.taskConfiguration?.offsetAmount,
              offsetDirection: item?.taskConfiguration?.offsetDirection,
              referenceFieldKey: item?.taskConfiguration?.referenceFieldKey,
              taskType: item?.taskConfiguration?.taskType,
              taskTypeConfiguration: item?.taskConfiguration?.taskTypeConfiguration,
              title: item?.taskConfiguration?.title,
            })),
          })),
        },
      }
    : undefined

  return {
    loading,
    materializedProcess: materializedProcessTransformed as MaterializedProcess | undefined,
  }
}
